import React, { useState } from 'react';
import { Box, Dialog, IconButton, Typography } from '@material-ui/core';
import { Close, Assignment } from '@material-ui/icons';
import instructions from './instructions';
import styles from './InstructionsStyles';
import InstructionItem from './InstructionItem';

const InstructionsList = ({ setOpen }) => {
  const [selectedInstruction, setSelectedInstruction] = useState(null);
  const [openNext, setOpenNext] = useState(false);

  const closeModalStyle = {
    container: {
      position: 'absolute',
      top: 24,
      right: 16,
    },
    closeIcon: {
      borderRadius: '6px',
      backgroundColor: 'black',
      color: 'white',
      fontWeight: 'bold',
      padding: 2,
    },
  };

  const handleClick = id => {
    const instruction = instructions.find(item => item.id === id);
    setSelectedInstruction(instruction);
    setOpenNext(true);
  };

  return (
    <div style={styles.instructionsWrapper}>
      <div style={styles.header}>
        <Box sx={closeModalStyle.container}>
          <IconButton onClick={() => setOpen(false)} style={closeModalStyle.closeIcon}>
            <Close />
          </IconButton>
        </Box>
        <div style={styles.titleHeaderWrapper}>
          <Typography variant="h5" component="h5" style={styles.titleHeader}>
            Инструкции за безопасна работа при технически дейности и мероприятия
          </Typography>
        </div>
      </div>
      <ul style={styles.listWrapper}>
        {instructions.map(item => (
          <li key={item.id} style={styles.listItem}>
            <div>
              <Assignment style={styles.icon} />
            </div>
            <div style={styles.textWrapper}>
              <Typography variant="subtitle1" style={styles.label}>
                Инструкция №{item.id}
              </Typography>
              <Typography variant="h6" style={styles.text} onClick={() => handleClick(item.id)}>
                {item.name}
              </Typography>
            </div>
          </li>
        ))}
      </ul>
      {selectedInstruction && (
        <Dialog open={openNext} fullScreen>
          <Box>
            <InstructionItem instruction={selectedInstruction} setOpenNext={setOpenNext} />
          </Box>
        </Dialog>
      )}
    </div>
  );
};

export default InstructionsList;
